import { useEffect, useRef } from 'react';

const INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

const useFlightWorker = (handleFlights, enabled = true) => {
    const ref = useRef(handleFlights);
    ref.current = handleFlights;

    useEffect(() => {
        if (!enabled) return;

        const tick = () => ref.current?.();

        const intervalId = setInterval(tick, INTERVAL_MS);
        return () => clearInterval(intervalId);
    }, [enabled]);
};

export default useFlightWorker;
